// extracted by mini-css-extract-plugin
export default {"closeIcon":"G3db21e Gf8b8ff G5e65f6 Ga51246"};